export default __webpack_public_path__ + "static/media/txt_filter_info.ef102d76.svg";